export default __webpack_public_path__ + "static/media/finland2.36180aa7.jpg";